import { call, put, SagaReturnType, select, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'

import orderModel from '@/core/models/order.model'

import { selectBulkOrderById, updateBulkOrderSuccess as updateBulkOrderSuccessAction } from '@/redux/reducers/bulk-order.reducer'
import {
  createOrder as createOrderAction,
  createOrderSuccess as createOrderSuccessAction,
  createOrderFailure as createOrderFailureAction,
  getOrderByReferenceId as getOrderByReferenceIdAction,
  getOrderSuccess as getOrderSuccessAction,
  getOrderFailure as getOrderFailureAction,
  listOrders as listOrdersAction,
  listOrdersSuccess as listOrdersSuccessAction,
  listOrdersFailure as listOrdersFailureAction,
  updateOrder as updateOrderAction,
  updateOrderSuccess as updateOrderSuccessAction,
  updateOrderFailure as updateOrderFailureAction,
} from '@/redux/reducers/order.reducer'
import { handleError } from '@/utils/errors'

export function* createOrder(action: PayloadAction<ReturnType<typeof createOrderAction>['payload']>) {
  try {
    const order: SagaReturnType<typeof orderModel.createOrder> = yield call(orderModel.createOrder, action.payload)
    yield put(createOrderSuccessAction(order))
  } catch (exception) {
    yield put(createOrderFailureAction(handleError(exception)))
  }
}

export function* getOrderByReferenceId(action: PayloadAction<ReturnType<typeof getOrderByReferenceIdAction>['payload']>) {
  try {
    const order: SagaReturnType<typeof orderModel.getOrderByReferenceId> = yield call(orderModel.getOrderByReferenceId, action.payload)
    yield put(getOrderSuccessAction(order))
  } catch (exception) {
    yield put(getOrderFailureAction(handleError(exception)))
  }
}

export function* listOrders(action: PayloadAction<ReturnType<typeof listOrdersAction>['payload']>) {
  try {
    const { query, options } = action.payload
    const { items, totalCount }: SagaReturnType<typeof orderModel.listOrders> = yield call(orderModel.listOrders, query, options)
    yield put(listOrdersSuccessAction({ items, totalCount }))
  } catch (exception) {
    yield put(listOrdersFailureAction(handleError(exception)))
  }
}

export function* updateOrder(action: PayloadAction<ReturnType<typeof updateOrderAction>['payload']>) {
  try {
    const { orderId, updateOrderDto } = action.payload
    const updatedOrder: SagaReturnType<typeof orderModel.updateOrder> = yield call(orderModel.updateOrder, orderId, updateOrderDto)
    yield put(updateOrderSuccessAction(updatedOrder))
  } catch (exception) {
    yield put(updateOrderFailureAction(handleError(exception)))
  }
}

const sagas = [
  takeLatest(createOrderAction.type, createOrder),
  takeLatest(getOrderByReferenceIdAction.type, getOrderByReferenceId),
  takeLatest(listOrdersAction.type, listOrders),
  takeLatest(updateOrderAction.type, updateOrder),
]

export default sagas
